import { Tag, Title } from 'autogen/translation-keys/trans-website-booking-consultationlist-contentheader';
import ContentHeader, { type ContentHeaderProps } from 'components/ContentHeader';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ConsultationContentHeader(props: Omit<ContentHeaderProps, 'tag' | 'title' | 'theme'>) {
    const { t } = useTranslation();
    return <ContentHeader tag={t(Tag)} title={t(Title)} theme="ClubMatas" {...props} />;
}
